exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dropdown-button.widget {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dropdown-button.widget.no-button {\n  background: none;\n  padding: 0;\n  margin: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/widget/dropdown-button/index.css
// module id = 490
// module chunks = 0